import BasePropertyView from 'BasePropertyView.js';
import listService  from 'ListService';
import constants    from 'Constants.js';
import Template     from 'behaviors/properties/main/behavior-instance.ejs';
import $ from "jquery";
//=====================================================================
//
// An instance of this view represents a behavior instance.
//
//=====================================================================

class BehaviorInstanceView extends BasePropertyView {

    initialize( opts ) {

        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change input[type=checkbox]' : 'updateCheckAttributes'
        };

        return this;
    }


    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        const pg = listService.getPage(listService.currentPageId);
        const inst = pg.model.get('behaviors').find(x => x.id = this.model.get('id'));
        if (inst) {
            inst.name = propVal;
        }

        this.model.set( propName, propVal );
        $(document).trigger(constants.EV_PAGE_OBJECTS_UPDATED, ['update', 'behavior', this.model.get('id'), propVal, this.model.get('pageId'),this.model.get('id') ]);
    }

    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;
        this.model.set( propName, propVal );
    }


    updateStatus(){

        const id = this.model.get("id");
        const commands = listService.getBehaviorsByInstanceId(id);
        const connections = listService.getConnectionsByInstanceId(id);
        
        const element=$("textarea[id='status']");
        let backgroundColor = '#F57979';
        let text = 'No commands.';
      
        const getTargets = (connections, tag) =>{            
            let map = new Map();
            let value = "";
            connections.forEach(conn => {
                value = conn.model.get(tag);
                if(value){
                    map.set(value.id,{id: value.id});
                }              
            });    
            return map;
        };

        const checkStartingPoint = (commands, targets, sources) => {
            let startPoints = [];
            let startPointCounter = 0;
            let id = "";

            commands.forEach(command => {
                id = command.model.get("id");
                if((!targets.get(id) && sources.get(id)) || (!targets.get(id) && !sources.get(id))){
                    startPoints.push(id);
                }
            });

            startPointCounter = startPoints.length;

            //Check if the starting point is valid
            if (startPointCounter === 1 && sources.size) {
                if (!sources.get(startPoints[0])) {
                    startPointCounter = -1;
                }
            }

            return startPointCounter;            
        };

        if(commands.size){
            const targets = getTargets(connections, 'destWidgetModel');
            const sources = getTargets(connections, 'srcWidgetModel');
            const startPoints = checkStartingPoint(commands, targets, sources);
           
            switch(startPoints){
                case -1:
                    text = "No logical flow.";
                break;
                
                case 0:
                    text = "No starting point.";
                break;

                case 1:
                    backgroundColor = "#FFFFFF";
                    text = "OK";
                break;

                default:
                    text = "More than one starting point.";
                break;
            }
        }

        element.css('background-color', backgroundColor);
        element.html(text);        
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        this.updateStatus();        
        this.delegateEvents();
        return this;
    }

}

export default BehaviorInstanceView;
